<template>
  <a-config-provider :locale="zhCN">
    <div id="app" ref="scrollContainer">
      <router-view :key="route.name"></router-view>
      <!-- height: 196px; -->
      <div
        style="
          position: fixed;
          bottom: 80px;
          right: 20px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
          width: 50px;
          height: 160px;
          border-radius: 25px;
          background: #1c4f91;
          z-index: 99;
          padding-top: 20px;
          box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.1);
        "
      >
        <!-- <div style="cursor: pointer; margin-bottom: 10px">
          <a-popover placement="left">
            <template #content>
              <div
                style="
                  color: #000;
                  font-size: 16px;
                  margin-bottom: 10px;
                  font-weight: 600;
                "
              >
                在线咨询
              </div>
              <div style="color: #666">专属客服经理1对1解答</div>
            </template>
            <img
              style="height: 28px; width: 28px"
              src="@/assets/chat-1.png"
              alt=""
              @click="openChat()"
            />
          </a-popover>
        </div> -->
        <div style="cursor: pointer; margin-bottom: 10px">
          <a-popover placement="left">
            <template #content>
              <div
                style="
                  color: #000;
                  font-size: 16px;
                  margin-bottom: 10px;
                  font-weight: 600;
                "
              >
                扫码咨询
              </div>
              <div style="color: #666; display: flex">
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    cursor: pointer;
                  "
                  @click="
                    openModal(
                      'https://daojuji.oss-cn-hangzhou.aliyuncs.com/ykt/wx.png',
                      '微信'
                    )
                  "
                >
                  <img
                    src="https://daojuji.oss-cn-hangzhou.aliyuncs.com/ykt/wx.png"
                    alt=""
                    style="height: 200px"
                  />
                  <div>微信</div>
                </div>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    cursor: pointer;
                    margin: 0 20px;
                  "
                  @click="
                    openModal(
                      'https://daojuji.oss-cn-hangzhou.aliyuncs.com/ykt/qywx.png',
                      '企业微信'
                    )
                  "
                >
                  <img
                    src="https://daojuji.oss-cn-hangzhou.aliyuncs.com/ykt/qywx.png"
                    alt=""
                    style="height: 200px"
                  />
                  <div>企业微信</div>
                </div>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    cursor: pointer;
                  "
                  @click="
                    openModal(
                      'https://daojuji.oss-cn-hangzhou.aliyuncs.com/ykt/qq.png',
                      'QQ'
                    )
                  "
                >
                  <img
                    src="https://daojuji.oss-cn-hangzhou.aliyuncs.com/ykt/qq.png"
                    alt=""
                    style="height: 200px"
                  />
                  <div>QQ</div>
                </div>
              </div>
            </template>
            <img
              style="height: 36px; width: 36px"
              src="@/assets/chat-2.png"
              alt=""
            />
          </a-popover>
        </div>
        <div style="cursor: pointer; margin-bottom: 10px">
          <a-popover placement="left">
            <template #content>
              <div
                style="
                  color: #000;
                  font-size: 16px;
                  margin-bottom: 10px;
                  font-weight: 600;
                "
              >
                联系邮箱
              </div>
              <div style="color: #666">15995497730@163.com</div>
            </template>
            <img
              style="height: 30px; width: 30px"
              src="@/assets/chat-3.png"
              alt=""
            />
          </a-popover>
        </div>
        <div style="cursor: pointer">
          <a-popover placement="left">
            <template #content>
              <div
                style="
                  color: #000;
                  font-size: 16px;
                  margin-bottom: 10px;
                  font-weight: 600;
                "
              >
                电话咨询
              </div>
              <div style="color: #666">0512-69356871/2/3</div>
            </template>
            <img
              style="height: 30px; width: 30px"
              src="@/assets/chat-4.png"
              alt=""
            />
          </a-popover>
        </div>
      </div>

      <div
        v-if="isOpenChat"
        style="
          position: fixed;
          height: 500px;
          width: 400px;
          bottom: 0;
          right: 0;
          z-index: 9999;
        "
      >
        <iframe
          src="http://chat.szktr.cn/"
          frameborder="0"
          style="width: 100%; height: 100%"
        ></iframe>
      </div>

      <a-modal v-model:open="isOpenModal" :title="modalTitle" :footer="null">
        <img style="width: 100%" :src="modalSrc" alt="" />
      </a-modal>
    </div>
  </a-config-provider>
</template>

<script setup>
import { useRoute } from "vue-router";
import { ref } from "vue";
import zhCN from "ant-design-vue/es/locale/zh_CN";
const scrollContainer = ref(null);
const isOpenChat = ref(false);
const isOpenModal = ref(false);
const modalTitle = ref("");
const modalSrc = ref("");

import emitter from "@/utils/emitter";
const route = useRoute();
emitter.on("update", (val) => {
  scrollContainer.value.scrollTop = 0;
});

const openChat = () => {
  // isOpenChat.value = true;

  const url = "http://chat.szktr.cn"; // 要打开的URL
  const windowName = "在线咨询"; // 窗口名称

  // 设置窗口大小和位置
  const width = 400;
  const height = 500;
  const left = (window.screen.width - width) / 2;
  const top = (window.screen.height - height) / 2;

  // 窗口特性字符串
  const windowFeatures = `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes,status=yes`;

  // 打开新窗口
  window.open(url, windowName, windowFeatures);
};

const openModal = (src, title) => {
  isOpenModal.value = true;
  modalSrc.value = src;
  modalTitle.value = title;
};
</script>

<style>
.amap-marker-label {
  border: none;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  font-size: 20px;
  padding: 16px 30px;
  line-height: 30px;
  border-radius: 10px;
}
</style>
